export default "__VITE_ASSET__CML2QmNz__";